export default __webpack_public_path__ + "static/media/northeastern.0e139a93.png";